import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

/**
 * Hook to initialize Capacitor plugins on app start
 */
export const useCapacitorInit = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const initializeCapacitor = async () => {
      try {
        // Listen for app state changes
        App.addListener('appStateChange', () => {});

        // Handle app URL open events
        App.addListener('appUrlOpen', () => {});
      } catch {
        // Silently handle initialization errors
      }
    };

    initializeCapacitor();

    return () => {
      // Cleanup listeners on unmount
      App.removeAllListeners();
    };
  }, []);

  return {
    isNativePlatform: Capacitor.isNativePlatform()
  };
};